import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitlabDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 54 54",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M53.9082 29.4384L46.5444 4.38795C46.085 3.00977 44.9838 2.08423 43.5111 2.08423C42.0383 2.08423 40.8425 2.91519 40.3832 4.29337L35.5055 18.8453H18.4877L13.61 4.30012C13.1506 2.92195 11.9548 2.09098 10.4821 2.09098C9.00933 2.09098 7.81355 3.00977 7.44874 4.3947L0.0916993 29.4384C-0.185288 30.3572 0.18628 31.3705 0.92266 31.9245L26.9594 51.4487L53.084 31.9245C53.8136 31.3773 54.1852 30.3639 53.9082 29.4384Z",
		fill: "currentColor",
		fillOpacity: .85
	})]
});
const ForwardRef = forwardRef(SvgGitlabDark);
export { ForwardRef as ReactComponent };
